<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zpVO90/tc-custom/9781451620542.jpg?1730494024411" alt="This image is the cover for the book Kindling the Moon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kindling the Moon
      </h1>
      <p class="bookDescription body article font2">
        <b>Meet Arcadia Bell</b><b>: </b><b>bartender, renegade magician, fugitive from the law. . . .</b><br/><br/>Being the spawn of two infamous occultists (and alleged murderers) isn’t easy, but freewheeling magician Arcadia “Cady” Bell knows how to make the best of a crummy situation. After hiding out for seven years, she’s carved an incognito niche for herself slinging drinks at the demon-friendly Tambuku Tiki Lounge. <br/><br/>But she receives an ultimatum when unexpected surveillance footage of her notorious parents surfaces: either prove their innocence or surrender herself. Unfortunately, the only witness to the crimes was an elusive Æthyric demon, and Cady has no idea how to find it. She teams up with Lon Butler, an enigmatic demonologist with a special talent for sexual spells and an arcane library of priceless stolen grimoires. Their research soon escalates into a storm of conflict involving missing police evidence, the decadent Hellfire Club, a ruthless bounty hunter, and a powerful occult society that operates way outside the law. If Cady can’t clear her family name soon, she’ll be forced to sacrifice her own life . . . and no amount of running will save her this time.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jenn Bennett
      </h2>
      
      <p class="authorDescription body article">Jenn Bennett&#160;is the author of over a dozen books, including the young adult titles&#160;<I>Alex, Approximately</I>;<I>&#160;Serious Moonlight</I>;&#160;<I>Starry Eyes</I>; and&#160;<I>The Lady Rogue</I>. She also writes romance and fantasy for adults. Her books have earned multiple starred reviews, been Goodreads Choice Award Nominees, and have been included on annual Best Books lists from <I>Kirkus Reviews</I> and <I>Publishers Weekly</I>. In addition to being a writer, she&rsquo;s also an artist with a BFA in painting. She was born in Germany, has lived all over the US, and has traveled extensively throughout Europe, China, Taiwan, and Hong Kong. She currently lives near Atlanta with one husband and two dogs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8a0a907e